import React from "react";
import { LocalCharacterInitializer } from "../../../../entities/characters/Character";
import { ThemedCheckbox } from "../../../inputs/checkbox/ThemedCheckbox";
import { useAppDispatch } from "../../../../store/configureStore";
import { CharacterPropertyActions } from "../../../../store/stores/collection/characters/actions/CharacterPropertyActions";
import { Loader } from "../../../theming/loader/Loader";

type Props = { character: LocalCharacterInitializer }

export const JuiceIndicator: React.FC<Props> = (props: Props) => {
    const { character } = props;
    const dispatch = useAppDispatch();
    const juiceDisabled = character.pendingProperties['juiced'] != null;
    return (                
        <div className="metric-container">
            <div className="juice metric" role="button">
                    
                <label>Juiced? {(juiceDisabled) && <Loader size="XS" inline />}</label>
                <div className="value">
                    <ThemedCheckbox disabled={juiceDisabled} checked={character.juiced} setChecked={(checked) => dispatch(CharacterPropertyActions.setJuiced(character, checked))} />
                </div>
            </div>
        </div>
    );
}